import(/* webpackMode: "eager", webpackExports: ["SupportContactForm"] */ "/vercel/path0/apps/web/src/components/support/support-contact-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.5.14_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
